module.exports = __webpack_public_path__ + "img/s3.6bc2892f.svg";